import script from "./AnimatedPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedPlaceholder.vue?vue&type=style&index=0&id=81a2bfb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81a2bfb6"]])

export default __exports__